/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusSquareIcon24Regular = forwardRef('MinusSquareIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.5 11.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 2.25A4.25 4.25 0 0 0 2.25 6.5v11a4.25 4.25 0 0 0 4.25 4.25h11a4.25 4.25 0 0 0 4.25-4.25v-11a4.25 4.25 0 0 0-4.25-4.25h-11ZM3.75 6.5A2.75 2.75 0 0 1 6.5 3.75h11a2.75 2.75 0 0 1 2.75 2.75v11a2.75 2.75 0 0 1-2.75 2.75h-11a2.75 2.75 0 0 1-2.75-2.75v-11Z" })));
});
